
import React from "react";
import { useSearchParams } from "@rivtn/noseur";
import { i18nManager } from "../i18n";
import TeamTile from "./common/TeamTile";
import Pagination from "./common/Pagination";
import { Utils } from "../../../../utils";
import PageHead from "./common/PageHead";
import styles from "../assets/style.module.css";
import { ApiResponseData, BaseService, IProfileWebsite, ITeamHistory, OmneHostService, SanitizedResponse } from "../../../../services";

export interface TeamHistoryProps {
    website: IProfileWebsite;
}

function TeamHistory({ website }: TeamHistoryProps) {

    const labels = i18nManager.Labels.team_history;
    const omnehostService = OmneHostService.getInstance();
    const [teamHistories, setTeamHistories] = React.useState<ApiResponseData<ITeamHistory>>();
    const { page, setPage } = useSearchParams({ defaultInit: window.location.search, params: { page: 1 } });

    React.useEffect(fetchInformation, [omnehostService, page]);

    return (<>
        <PageHead kicker={labels.kicker} title={labels.title} titleEm={labels.title_em} subtitle={labels.desc} />
        <section className={styles["section"]}>
        <div className={styles["container"]}>

            {(!!teamHistories?.content)
                ? ((teamHistories.content.length > 0)
                    ? (<div className={styles["team-grid"]}>
                        {teamHistories.content.map((t) => (<TeamTile key={t.external_id} team={t} />))}
                    </div>)
                    : (Utils.emptyState()))
                : (Utils.loadingState())}

            <Pagination page={parseInt("" + page)} rowsPerPage={teamHistories?.size} totalRecords={teamHistories?.total_elements} onPageChange={setPage} />
        </div>
        </section>
    </>);

    function fetchInformation() {
        setTeamHistories({});
        omnehostService.queryMemberTeamHistory(website.member.username, {
            page,
            sort: ["updated_at,ASC", "status,ASC"],
        }).then(({ apiResponse }: SanitizedResponse<ITeamHistory>) => {
            setTeamHistories(apiResponse.data!);
        }).catch(BaseService.reportError);
    }
}

export default TeamHistory;
